import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

/**
 * UI状態を統合管理するスライス
 * 旧: blind.ts, first_view.ts, refresh_pdf.ts を統合
 */

type UIState = {
  /** ブラインドモード（個人情報を隠す） */
  blind: boolean;
  /** 初回表示フラグ */
  firstView: boolean;
  /** PDF再生成フラグ */
  refreshPdf: boolean;
};

const initialState: UIState = {
  blind: false,
  firstView: true,
  refreshPdf: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    updateBlind(state: UIState, action: PayloadAction<boolean>) {
      state.blind = action.payload;
    },
    updateFirstView(state: UIState, action: PayloadAction<boolean>) {
      state.firstView = action.payload;
    },
    updateRefreshPdf(state: UIState, action: PayloadAction<boolean>) {
      state.refreshPdf = action.payload;
    },
  },
});

export const { updateBlind, updateFirstView, updateRefreshPdf } = uiSlice.actions;

// Selectors
const _selectUI = (state: RootState) => state.ui;
const _selectBlind = (state: RootState) => state.ui.blind;
export const selectFirstView = (state: RootState) => state.ui.firstView;
export const selectRefreshPdf = (state: RootState) => state.ui.refreshPdf;

export default uiSlice.reducer;
